import type { RenderBlock } from "@/lib/chat-render";
import { toolCopyText } from "./tool-entry-label";

const BLOCK_SEPARATOR = "\n\n---\n\n";

function blockText(block: RenderBlock): string | null {
	switch (block.kind) {
		case "text":
			if (block.role === "user") return `ユーザー:\n${block.text}`;
			if (block.role === "assistant") return `エージェント:\n${block.text}`;
			if (block.role === "systemError") return `エラー:\n${block.text}`;
			return null;
		case "tool_use":
			return toolCopyText(block);
		case "compaction":
			return `会話の要約:\n${block.summaryText}`;
		case "system_notice":
		case "provider_outage":
			return `通知:\n${block.text}`;
	}
}

/** チャット履歴全体をコピー用のプレーンテキストにする。 */
export function chatTranscriptText(blocks: RenderBlock[]): string {
	return blocks
		.map(blockText)
		.filter((text) => text !== null)
		.join(BLOCK_SEPARATOR);
}
